import { carrotDomain } from './carrotDomain';

const authenticationEndpoint = `https://app.${carrotDomain()}/wp-json/carrot/v1/auth-api/`;

export { authenticationEndpoint };
